var map = {
	"./01Eplan.jpg": "546e",
	"./02Kuka.jpg": "d54d",
	"./03RockwellAutomation.jpg": "8d20",
	"./04Siemens.jpg": "6a21",
	"./05solidworks.jpg": "0dcf",
	"./06VisualComponentsLogo.jpg": "abbb",
	"./PheonixContact.jpg": "3e71",
	"./Ritual.jpg": "5266"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c5f";